import React from 'react'
import Logo from '../../images/handleandkate-logo.svg'

const Image = (props) => <img alt="Handle and Kate Logo" src={Logo} {...props} />

export default Image
